<template>
  <div class="ticket_block">
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（デフォルト）（リンクなし）
      </div>
      <Ticket
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :image-url="ticket.imageUrl"
        :is-ticket-expired="false"
        :is-ticket-sold-out="false"
        :item-name="ticket.itemName"
        :showable-giftee-asterisk="true"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（デフォルト）（リンクあり）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="false"
        :showable-giftee-asterisk="true"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（デフォルト）（期限なし）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :is-ticket-expired="false"
        :showable-giftee-asterisk="true"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（デフォルト）（アスタリスクなし）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="false"
        :showable-giftee-asterisk="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（期限切れ）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="true"
        :showable-giftee-asterisk="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（金額 or コース有り・アスタリスクあり）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="false"
        :showable-giftee-asterisk="true"
      />
      <div style="padding-bottom: 8px">
        カード型（金額 or コース有り・アスタリスクなし）
      </div>
      <TicketWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="false"
        :showable-giftee-asterisk="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        カード型（金額 or コース有り・アスタリスクあり）（期限切れ）
      </div>
      <Ticket
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expiration-date="ticket.expirationDate"
        :is-ticket-expired="true"
        :is-ticket-sold-out="false"
        :showable-giftee-asterisk="true"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        接着型（デフォルト）
      </div>
      <TicketConnected
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :price="ticket.price"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-ticket-expired="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        接着型（配送料有り）
      </div>
      <TicketConnected
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :price="ticket.price"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-ticket-expired="false"
        :shipping-cost="ticket.shippingCost"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        接着型（小）（購入履歴用）
      </div>
      <TicketDetailForPurchaseHistory
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :is-ticket-expired="false"
        :other-item-sku-contents-count="1"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        接着型（小）（購入履歴詳細用）
      </div>
      <TicketDetail
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-including-tax="ticket.isIncludingTax"
        :is-ticket-disabled="false"
        :price="ticket.price"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        接着型（小）（購入履歴詳細用）（item_skuあり）
      </div>
      <TicketDetail
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-including-tax="ticket.isIncludingTax"
        :is-ticket-disabled="false"
        :price="ticket.price"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        遷移タイプ（itemのみ）
      </div>
      <TicketConnectedWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :brand-name="ticket.brandName"
        :is-ticket-expired="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        遷移タイプ（item＋item_sku）
      </div>
      <TicketConnectedWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :is-ticket-expired="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        遷移タイプ（item＋item_sku+有効期限）
      </div>
      <TicketConnectedWithLink
        :link-url="ticket.linkUrl"
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :expiration-date="ticket.expirationDateForConnected"
        :brand-name="ticket.brandName"
        :is-ticket-expired="false"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        綴りあり（itemのみ）
      </div>
      <TicketConnectedMultiple
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-ticket-expired="false"
        :is-delivery-item="true"
        :is-including-tax="true"
        :price-with-shipping-cost="ticket.price"
        :shipping-cost="ticket.shippingCost"
        :ticket-count="ticket.ticketCount"
        :price="ticket.price"
      />
    </div>
    <div class="ticket_block">
      <div style="padding-bottom: 8px">
        綴りあり（item＋item_sku）
      </div>
      <TicketConnectedMultiple
        :image-url="ticket.imageUrl"
        :item-name="ticket.itemName"
        :item-sku-name="ticket.itemSkuName"
        :brand-name="ticket.brandName"
        :expired-date="ticket.expiredDate"
        :is-ticket-expired="false"
        :is-delivery-item="false"
        :is-including-tax="false"
        :price-with-shipping-cost="ticket.price"
        :shipping-cost="ticket.shippingCost"
        :ticket-count="ticket.ticketCount"
        :price="ticket.price"
      />
    </div>
  </div>
</template>
<script>
import Ticket from '../../components/atoms/tickets/Ticket'
import imageUrl from '../../../../images/styleguide/summer_01.svg'
import TicketConnected from '../../components/atoms/tickets/TicketConnected'
import TicketDetailForPurchaseHistory from '../../components/atoms/tickets/TicketDetailForPurchaseHistory'
import TicketDetail from '../../components/atoms/tickets/TicketDetail'
import TicketConnectedWithLink from '../../components/atoms/tickets/TicketConnectedWithLink'
import TicketConnectedMultiple from '../../components/atoms/tickets/TicketConnectedMultiple'
import TicketWithLink from '../../components/atoms/tickets/TicketWithLink'

export default {
  components: {
    TicketWithLink,
    TicketConnectedMultiple,
    TicketConnectedWithLink,
    TicketDetailForPurchaseHistory,
    TicketConnected,
    Ticket,
    TicketDetail
  },
  data() {
    return {
      ticket: {
        linkUrl: '/',
        imageUrl,
        itemName: 'ドリンクチケット',
        brandName: 'Starbucks Coffee Japan',
        expiredDate: '2019年02月28日',
        expirationDate: '2019/02/28 まで有効',
        expirationDateForConnected: '2019年09月30日まで有効',
        itemSkuName: '¥500',
        price: 3000100,
        shippingCost: 1864,
        ticketCount: 1,
        isIncludingTax: true
      }
    }
  },
  methods: {
    clickTicket() {
      alert('clicked ticket!!')
    }
  }
}
</script>
